import { TableWithStoredSettingsAndLayoutSettings } from '@Components/Tables/TableWithStoredSettingsAndLayoutSettings';
import { BILLING_API } from '@Constants/backendConstants';
import { Permission } from '@Constants/Permission.g';
import { cashJournalColumns } from '@Constants/TableColumns';
import { useHasPermission } from '@Contexts/appContext';
import { useExportOptions } from '@Hooks/Export';
import { ExportOptionsMenu, ExportOptionsModal } from '@Modules/Exports';
import { type ToolbarOptions } from '@synqo/frontend-component-library';
import { EnumFrontendLayoutSetting } from '@Model';
import { useListApi } from '@Hooks/useListApi';
import { CashJournalsRepository } from '@Repositories/Billing';

const cashJournalToolbarElements: ToolbarOptions[] = [
    'search',
    'add',
    'showHideColumns',
    'toggleDensePadding',
    'toggleFullScreen',
    'export',
    'scrollToTop',
];

export function FrameListCashJournal() {
    const hasPermission = useHasPermission();

    const module = useListApi(CashJournalsRepository, BILLING_API);

    const exportOptionsInfo = useExportOptions(BILLING_API, 'cash_journals');

    return (
        <>
            <TableWithStoredSettingsAndLayoutSettings
                layoutSettingsContext={EnumFrontendLayoutSetting.CashJournalsTableLayout}
                name={'CashJournalList'}
                columns={cashJournalColumns}
                loader={module.loadPage}
                canCreate={hasPermission(Permission.BillingCashJournalsCreate)}
                useOnClickNavigation
                initialSorting={{
                    columnName: 'date',
                    direction: 'desc',
                }}
                fullSize
                toolbarElements={cashJournalToolbarElements}
                renderExportComponent={() => <ExportOptionsMenu key="export" {...exportOptionsInfo} />}
            />
            <ExportOptionsModal {...exportOptionsInfo} />
        </>
    );
}
